<template>

  <div class="notfications">
    <ul>
      <li v-for="n in allNotifications" class="notification">
        <router-link :to="{name: n.navLocation}">{{n.message}}</router-link>
        <span v-if="showDelete === true" v-on:click="removeNotification(n)"><i class="fas fa-times"></i></span>
      </li>
      <li v-if="allNotifications.length > 0" v-on:click="removeAllNotifications()" class="clear-all notification">Cleare all notifications</li>
      <li class="xs-p-20" v-else>No new notifications</li>
    </ul>
  </div>

</template>

<script>
  import _ from 'underscore'
  import { mapState, mapActions, mapGetters } from 'vuex'

  export default {
    created() {
      
      this.getAllReceivedShares();
    },
  data() {
    return {}
    },

    props: {
      showDelete: Boolean, 
    },

  computed: {
    ...mapGetters({
      allNotifications: 'allNotifications',
    }),
  },

  methods: {
    ...mapActions([
    ]),
    getAllReceivedShares() {
      this.$store.dispatch('getAllReceivedShares', {
        callback: (error, shares) => {
          _.each(shares, (share) => {
            var existing = _.where(this.allNotifications, {
              itemId: share.id, itemType: 'share'
            });

            if (existing.length <= 0 && share.accepted !== true) {
              this.$store.commit('ADD_NOTIFICATION', {
                notification: {
                  id: new Date().getTime(),
                  message: share.sender_email + ' shared their study notes \'' + share.chapter_name + '\' with you.',
                  navLocation: 'receive-chapter',
                  itemId: share.id,
                  itemType: 'share',
                }
              });
            }
          });
        },
      });
    },

    removeNotification(n) {
      this.$store.commit('REMOVE_NOTIFICATION', { notification: n });
    },
    removeAllNotifications() {
      this.$store.commit('REMOVE_ALL_NOTIFICATIONS');
    },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  ul, ul li {padding:0px;margin:0px;list-style-type:none;}

  .notifications { padding: 15px 22px 14px 22px !important; color: #4285f4; font-size: 20px !important; line-height: 32px; position: relative; }
  .notifications span { position: absolute; top: 10px; right: 10px; font-size: 12px; border: 1px solid #4285f4 ;background:#FFFFFF;border-radius:10px;display:block;line-height:20px;height:20px;min-width:20px;text-align:center;}

  .notification { position: relative; }
  .notification a { padding: 10px 20px; display: block; color:#444444;background:#FFFFFF;}
  .notification:nth-child(even) a { background: #F6F6F6; }
  .notification span {display:none;position:absolute;top:10px;right:10px;cursor:pointer;}
  .notification:hover a { background: #4285f4; color: #FFFFFF; }
    .notification:hover span { display: block; color: #FFFFFF; }
  .clear-all { padding: 20px 20px; cursor: pointer; background: #FFFFFF !important; text-align: center; border-top: 1px solid #DDDDDD; }
  .clear-all:hover { background: #4285f4 !important; color: #FFFFFF; }
</style>



// WEBPACK FOOTER //
// NotificationList.vue?bf48f5fc